import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center py-20 px-4 overflow-hidden" data-id="element-135">
      {/* Background Ambience — soft feminine glows */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-136">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#f4b8c8] rounded-full mix-blend-multiply filter blur-[128px] opacity-30 animate-pulse" style={{
        animationDuration: '4s'
      }} data-id="element-137"></div>
        <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-[#d4c0e8] rounded-full mix-blend-multiply filter blur-[96px] opacity-25 animate-pulse" style={{
        animationDuration: '6s'
      }} data-id="element-138"></div>
        <div className="absolute top-1/2 right-1/3 w-72 h-72 bg-[#fce4ec] rounded-full mix-blend-multiply filter blur-[100px] opacity-40 animate-pulse" style={{
        animationDuration: '5s'
      }} data-id="element-139"></div>
      </div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-140">
        {/* Text Content */}
        <div className="text-center lg:text-left space-y-8 order-1" data-id="element-141">
          <FadeIn delay={0.2} data-id="element-142">
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-script text-[#c4607a] mb-4 leading-tight drop-shadow-sm" data-id="element-143">
              Lo Estás <br data-id="element-144" />
              Haciendo Bien
            </h1>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-145">
            <p className="text-xl md:text-2xl text-[#5a3545] font-light leading-relaxed max-w-xl mx-auto lg:mx-0" data-id="element-146">
              La guía emocional para dejar de pelear por lo mismo y volver a
              sentir conexión en pareja
            </p>
          </FadeIn>

          <FadeIn delay={0.6} data-id="element-147">
            <a href="#precio" onClick={e => {
            e.preventDefault();
            document.getElementById('precio')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="group bg-[#c4607a] hover:bg-[#b35068] text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-[0_4px_24px_rgba(196,96,122,0.25)] hover:shadow-[0_6px_32px_rgba(196,96,122,0.4)] flex items-center gap-2 mx-auto lg:mx-0 no-underline" data-id="element-148">
              Quiero mi guía
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-149" />
            </a>
          </FadeIn>
        </div>

        {/* Book Image */}
        <div className="order-2 flex justify-center" data-id="element-150">
          <FadeIn delay={0.4} direction="none" className="relative" data-id="element-151">
            <div className="absolute inset-0 bg-[#e8a0b5] blur-[60px] opacity-30 rounded-full transform scale-90" data-id="element-152"></div>
            <motion.img src="https://cdn.magicpatterns.com/uploads/23xQnoLCh3GWCv8zaG2H5B/LO_ESTAS_HACIENDO_BIEN_1X1_IMAGEN.png" alt="Lo Estás Haciendo Bien Libro" className="relative w-full max-w-md rounded-lg shadow-[0_20px_60px_rgba(196,96,122,0.2)] transform rotate-[-2deg] hover:rotate-0 transition-transform duration-700 ease-out" initial={{
            scale: 0.9,
            opacity: 0
          }} animate={{
            scale: 1,
            opacity: 1
          }} transition={{
            duration: 1.2,
            ease: 'easeOut'
          }} data-id="element-153" />
          </FadeIn>
        </div>
      </div>
    </section>;
}